import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import { SxProps } from '@mui/material';
import { headerMobileLinkBaseSX } from '@/components/content/Header/styles/mobileDrawer';
import { LinkProps } from 'next/link';
import { SyntheticEvent } from 'react';

interface MobileLinkProps {
	name: string;
	icon: JSX.Element;
	href?: LinkProps['href'];
	target?: string;
	sx?: SxProps;
	onLinkClick?: (event: SyntheticEvent) => void;
}

export const MobileLink: React.FC<MobileLinkProps> = ({
	name,
	icon,
	href,
	target,
	sx,
	onLinkClick,
}) => (
	<Linkable
		type={onLinkClick ? 'button-base' : 'link'}
		href={href}
		target={target}
		sx={combineSX([headerMobileLinkBaseSX, sx])}
		onClick={onLinkClick}
	>
		{icon}
		{name}
	</Linkable>
);
